module.exports = __webpack_public_path__ + "static/img/info9.4e9ea32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/info9.jpg
// module id = AoBj
// module chunks = 1